import { AbstractControl, Validators } from '@angular/forms';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';
import { hasNoValue, isString } from '@util';
import { isBoxed, unbox } from 'ngrx-forms';
import * as R from 'ramda';

const defaultMessage = 'general.message.fieldRequired';

const consistsOnlyOfEmptySpaces = R.ifElse(isString, R.compose(hasNoValue, R.trim), R.F);
export const requiredValueValidator: any = (value: any): any => {
  const unBoxedValue = isBoxed(value) ? unbox(value) : value;
  return hasNoValue(unBoxedValue) || consistsOnlyOfEmptySpaces(unBoxedValue) ? createValidationError('required', defaultMessage) : null;
};

export const requiredValidator = (message: string = defaultMessage) =>
  (control: AbstractControl): PcsValidationErrors => {
    if (Validators.required(control)) {
      return createValidationError('required', message);
    }
  };
